/**
 * Cola secuencial GLOBAL para descargas de archivos (PDF/XML/documentos).
 *
 * Directiva del proyecto: las descargas se piden DE UNA EN UNA — sin
 * peticiones paralelas, sin ráfagas y sin pausas artificiales. Cada descarga
 * encolada arranca inmediatamente cuando termina la anterior (éxito o error);
 * un fallo no rompe la cola para las siguientes.
 */
let cola: Promise<unknown> = Promise.resolve();

export function encolarDescarga<T>(descarga: () => Promise<T>): Promise<T> {
  const turno = cola.then(descarga);
  // La cola avanza siempre · el error se propaga solo al caller de ESTE turno.
  cola = turno.catch(() => undefined);
  return turno;
}
